import { Col, Radio, RadioChangeEvent, Row } from 'antd'
import { infoMessage } from 'api/global'
import { useLeagueStep10Communication } from 'api/league/LeagueCreation/leagueCreation'
import { useGetOrganizationDetails } from 'api/Organizations'
import CustomModal from 'components/global/CustomModal'
import CustomModalFooter from 'components/global/CustomModalFooter'
import Spinner from 'components/Spinner'
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { leagueEventStore } from 'state/league/leagueEvent'
import { myStore } from 'state/store'
import { EventStatus } from 'types/event/eventStep5'

interface ConfirmationModalProps {
  openModal: boolean
  setopenModal: React.Dispatch<React.SetStateAction<boolean>>
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  openModal,
  setopenModal,
}) => {
  const history = useHistory()
  const { leagueData, setLeagueData, leagueStepCounter, setLeagueStepCounter } =
    leagueEventStore(store => ({
      leagueData: store.leagueData,
      setLeagueData: store.setLeagueData,
      leagueStepCounter: store.leagueStepCounter,
      setLeagueStepCounter: store.setLeagueStepCounter,
    }))
  const setModalBtnLoader = myStore(store => store.setModalBtnLoader)
  const [eventStatus, setEventStatus] = useState<EventStatus>(
    leagueData?.status || 'draft',
  )
  const { mutate: changeStatusMutation } = useLeagueStep10Communication()

  const {
    data: organizationDetials,
    isLoading: orgLoading,
    isFetching: orgFetching,
    refetch,
  } = useGetOrganizationDetails(leagueData?.organizationId)

  const handleRadioChange = (e: RadioChangeEvent) => {
    const selected = e.target.value as EventStatus

    if (selected === 'draft') {
      setEventStatus(selected)
      return
    }
    if (organizationDetials?.status !== 'approved') {
      infoMessage(
        'Organization is not approved yet! Only allowed to change status to "draft"',
      )
      return
    }
    setEventStatus(selected)
  }

  const handleSaveEvent = () => {
    setModalBtnLoader(true)
    changeStatusMutation(
      { payload: { status: eventStatus }, leagueId: leagueData._id },
      {
        onSuccess: () => {
          setLeagueData(null)
          setLeagueStepCounter(0)
          setModalBtnLoader(false)
          history.push(`/spaces?page=1&limit=10`)
        },
        onError: () => {
          setModalBtnLoader(false)
        },
      },
    )
  }

  useEffect(() => {
    refetch()
  }, [])
  return (
    <>
      <CustomModal
        openModal={openModal}
        closeModal={setopenModal}
        width={700}
        title="Confirmation"
        footer={
          <CustomModalFooter
            multibutton={true}
            btnText="Cancel,Save"
            btnAlignment="justify-between"
            closeModal={setopenModal}
            onSubmit={handleSaveEvent}
          />
        }
      >
        <>
          {orgLoading || orgFetching ? (
            <div className="h-15 flex justify-center align-center">
              <Spinner />
            </div>
          ) : (
            <div>
              <div className="h-22rem scroller scroller-lg overflow-auto-y overflow-hidden-x">
                <Radio.Group value={eventStatus} onChange={handleRadioChange}>
                  <Row>
                    <Col className="d-flex justify-between align-items-start mt-20">
                      <div>
                        <h2 className="text-16 w-600">Draft</h2>
                        <p className="text-14 w-400 text-gray mt-5px">
                          Only visible to organizers
                        </p>
                      </div>
                      <Radio className="radio mr-0" value={'draft'} />
                    </Col>
                  </Row>
                  {/* {organizationDetials.status === 'approved' && ( */}
                  <div>
                    <Row>
                      <Col className="d-flex justify-between align-items-start mt-20">
                        <div>
                          <h2 className="text-16 w-600">Private</h2>
                          <p className="text-14 w-400 text-gray mt-5px">
                            Only visible by shared link
                          </p>
                        </div>
                        <Radio className="radio mr-0" value={'private'} />
                      </Col>
                    </Row>
                    <Row>
                      <Col className="d-flex justify-between align-items-start mt-20">
                        <div>
                          <h2 className="text-16 w-600">Following</h2>
                          <p className="text-14 w-400 text-gray mt-5px">
                            Visible to all families following the organization
                          </p>
                        </div>
                        <Radio className="radio mr-0" value={'following'} />
                      </Col>
                    </Row>
                    <Row>
                      <Col className="d-flex justify-between align-items-start mt-20">
                        <div>
                          <h2 className="text-16 w-600">Subscribed</h2>
                          <p className="text-14 w-400 text-gray mt-5px">
                            Visible to all families subscribed and approved the
                            organization
                          </p>
                        </div>
                        <Radio className="radio mr-0" value={'subscribed'} />
                      </Col>
                    </Row>
                    <Row>
                      <Col className="d-flex justify-between align-items-start mt-20">
                        <div>
                          <h2 className="text-16 w-600">Mentor social</h2>
                          <p className="text-14 w-400 text-gray mt-5px">
                            Visible to Mentors on their separate app
                          </p>
                        </div>
                        <Radio className="radio mr-0" value={'mentor_social'} />
                      </Col>
                    </Row>
                    <Row>
                      <Col className="d-flex justify-between align-items-start mt-20">
                        <div>
                          <h2 className="text-16 w-600">Public</h2>
                          <p className="text-14 w-400 text-gray mt-5px">
                            Visible to all families
                          </p>
                        </div>
                        <Radio className="radio mr-0" value={'public'} />
                      </Col>
                    </Row>
                  </div>
                  {/* )} */}
                </Radio.Group>
              </div>
            </div>
          )}
        </>
      </CustomModal>
    </>
  )
}

export default ConfirmationModal
